import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";

import EditArtworkIcon from '@/assets/all-icons/edit-artwork-icon';
import Text from '@/shared-components/text/components/Text';

import './styles/AddressCard.css';

export default function AddressCard({
  addressData,
  isPreferred = false,
  onSelectPreferred,
  setAddressToEdit,
  setAddressToRemove,
}) {
  function handleContainerKeyDown(event) {
    if (!onSelectPreferred) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelectPreferred(addressData);
    }
  }

  function handleContainerClick() {
    if (onSelectPreferred) {
      onSelectPreferred(addressData);
    }
  }

  function handleEditClick(event) {
    event.stopPropagation();
    setAddressToEdit(addressData);
  }

  function handleRemoveClick(event) {
    event.stopPropagation();
    setAddressToRemove(addressData);
  }

  return (
    <>
      <div className="address-item__container">
        <DeleteIcon className="address-item__remove-address" onClick={handleRemoveClick} />

        <div
          className={`address-item__address-info-container${isPreferred ? ' preferred' : ''}`}
          role="button"
          tabIndex={0}
          onClick={handleContainerClick}
          onKeyDown={handleContainerKeyDown}
        >
          <div className="address-item__address-info-text-container">
            <Text
              className="address-item__address-info-text text-margin font-size-medium"
              paragraph>
              {addressData.address_name} {addressData.address_surname}
            </Text>

            <Text
              className="address-item__address-info-text text-margin font-size-medium"
              paragraph>
              {addressData.address_address || addressData.address_street}
            </Text>

            <Text
              className="address-item__address-info-text text-margin font-size-medium"
              paragraph>
              {addressData.address_city}, {addressData.address_zip_code}
            </Text>

            <Text
              className="address-item__address-info-text text-margin font-size-medium"
              paragraph>
              {addressData.address_region}, {addressData.address_country}
            </Text>

            <Text
              className="address-item__address-info-text text-margin font-size-medium"
              paragraph>
              {addressData.address_phone.address_phone_prefix} {addressData.address_phone.address_phone_number}
            </Text>
          </div>

          <EditArtworkIcon className="address-item__address-info-edit-button" onClick={handleEditClick} />
        </div>
      </div>
    </>
  );
}
